import { GenericAbortSignal } from 'axios';

import { Paginated } from 'models/Paginated';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export interface TaggableUser {
  id: string;
  groupName: string;
  name: string;
}

export type TaggableUserProps = {
  onReview?: string;
};

type IndexParams = {
  locationEpisodeId: string;
} & TaggableUserProps &
  BaseIndexQueryParams;
export async function indexTaggableUsers(
  { locationEpisodeId, onReview, ...params }: IndexParams,
  signal: GenericAbortSignal
) {
  const url = onReview ? `reviews/${onReview}/taggable_users` : `location_episodes/${locationEpisodeId}/taggable_users`;
  return http
    .get<Paginated<TaggableUser>>(url, {
      params,
      signal,
    })
    .then((res) => ({
      ...res.data,
      data: res.data.data.map((user) => ({
        ...user,
        display: `${user.name} - ${user.groupName}`,
      })),
    }));
}
